/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Input for creating an OAuth application.
 * @export
 * @interface OAuthApplicationCreateRequest
 */
export interface OAuthApplicationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OAuthApplicationCreateRequest
     */
    name: string;
}

/**
 * Check if a given object implements the OAuthApplicationCreateRequest interface.
 */
export function instanceOfOAuthApplicationCreateRequest(value: object): value is OAuthApplicationCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function OAuthApplicationCreateRequestFromJSON(json: any): OAuthApplicationCreateRequest {
    return OAuthApplicationCreateRequestFromJSONTyped(json, false);
}

export function OAuthApplicationCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthApplicationCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function OAuthApplicationCreateRequestToJSON(json: any): OAuthApplicationCreateRequest {
    return OAuthApplicationCreateRequestToJSONTyped(json, false);
}

export function OAuthApplicationCreateRequestToJSONTyped(value?: OAuthApplicationCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

